import React, { useEffect } from 'react';
import { BitMap, Color } from '@/src/components/canvas/bitmap';

export function buildCanvas(bitMap: BitMap<Color>, pipe?: (img: ImageData) => ImageData, size?: number): HTMLCanvasElement {
  const _size = size ?? 1;
  const canvas = document.createElement('canvas');
  const { width, height } = bitMap;
  canvas.width = width * _size;
  canvas.height = height * _size;
  const ctx = canvas.getContext('2d');
  for (let x = 0; x < width; x++)
    for (let y = 0; y < height; y++) {
      const c = bitMap.get(x, y);
      const { r, g, b, a } = c;
      ctx.fillStyle = `rgba(${r},${g},${b},${a})`;
      ctx.fillRect(x * _size, y * _size, _size, _size);
    }
  if (pipe) {
    ctx.putImageData(pipe(ctx.getImageData(0, 0, canvas.width, canvas.height)), 0, 0);
  }
  return canvas;
}

export function ColorBitMapPreview(props: { bitMap: BitMap<Color>, size?: number }) {
  const { bitMap } = props;
  const size = props.size ?? 10;
  const ref = React.createRef<HTMLDivElement>();
  useEffect(() => {
    if (ref.current) {
      const build = (pipe: (d: ImageData) => ImageData) => buildCanvas(bitMap, pipe, size);
      const root = ref.current;
      const append = (title: string, pipe: (d: ImageData) => ImageData) => {
        const wrap = document.createElement('div');
        const label = document.createElement('span');
        label.textContent = title;
        wrap.appendChild(label);
        wrap.appendChild(build(pipe));
        root.appendChild(wrap);
      }
      append('原始:', x => x);
      append('invert 滤镜:', window.bex.bild.effect.invert);
      append('sepia 滤镜:', window.bex.bild.effect.sepia);
      append('emboss 滤镜:', window.bex.bild.effect.emboss);
      append('grayscale 滤镜:', window.bex.bild.effect.grayscale);
      append('sharpen 滤镜:', window.bex.bild.effect.sharpen);
      append('sobel 滤镜:', window.bex.bild.effect.sobel);
      append('dilate 0.5 滤镜:', img => window.bex.bild.effect.dilate(img, 0.5));
      append('edge_detection 0.5 滤镜:', img => window.bex.bild.effect.edge_detection(img, 0.5));
      append('erode 0.5 滤镜:', img => window.bex.bild.effect.erode(img, 0.5));
      append('grayscale_with_weights 0.5 滤镜:', img => window.bex.bild.effect.grayscale_with_weights(img, 0.5, 0.5, 0.5));
      append('median 0.5 滤镜:', img => window.bex.bild.effect.median(img, 0.5));
      append('unsharp_mask 0.5 滤镜:', img => window.bex.bild.effect.unsharp_mask(img, 0.5, 0.5));

    }
  }, [bitMap, size]);

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        gridGap: 20,
      }}
      ref={ref}
    />
  );
}